import { Component, Input, HostBinding, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-edit-googleplus-modal',
  styleUrls: ['./googleplus.component.less'],
  templateUrl: './googleplus.component.html',
})
export class EditGoogleplusModalComponent {
  @Input() close: Function;
  @HostBinding('class._is-authorize') isAuthorize = false;
  @ViewChild('input') input: ElementRef;

  authorize() {
    this.isAuthorize = true;
  }

  changeUser() {
    this.isAuthorize = false;
  }

  add() {
    if (!this.input.nativeElement.value) {
      return;
    }

    this.close();
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/integrations/googleplus/googleplus.component.ts